import { styled } from 'parkdepot-shared/theme'

export const FullWrapper = styled('div', ({ $theme }) => ({
    height: '100%',
    overflowY: 'auto',
    padding: '0 1.6rem',

    [$theme.mediaQuery.large]: {
        width: '37.5rem',
        margin: '0 auto'
    }
}))

export const Title = styled('h3', ({ $theme }) => ({
    ...$theme.typography.HeadingXSmall,
    fontWeight: 600,
    textAlign: 'center',
    margin: '2rem 0 4rem',

    [$theme.mediaQuery.large]: {
        ...$theme.typography.HeadingSmall,
        padding: 0
    }
}))

export const Subtitle = styled('h4', ({ $theme }) => ({
    ...$theme.typography.LabelLarge,
    margin: '4rem 0 2rem'
}))

export const NoPaymentMethodIcon = styled('i', ({ $theme }) => ({
    fontSize: '3.2rem'
}))

export const NoPaymentMethodText = styled('h3', ({ $theme }) => ({
    ...$theme.typography.LabelMedium,
    fontWeight: 700,
    margin: '0.8rem 0'
}))

export const NoPaymentMethodDescription = styled('p', ({ $theme }) => ({
    ...$theme.typography.ParagraphSmall,
    margin: 0
}))

export const PaymentMethodAddIcon = styled('i', ({ $theme }) => ({
    fontSize: '1.6rem',
    marginRight: '12px'
}))

export const NewPaymentMethodButtonOverride = {
    BaseButton: {
        style: {
            width: '100%'
        }
    }
}

export const AddPaymentMethodWrapper = styled('div', ({ $theme }) => ({
    backgroundColor: $theme.colors.white,
    paddingTop: '2rem',
    marginBottom: '1.6rem',
    borderTop: '1px solid #E5E5E5'
}))

export const NoPaymentMethodWrapper = styled('div', ({ $theme }) => ({
    backgroundColor: $theme.colors.white,
    borderRadius: '24px',
    padding: '2rem',
    textAlign: 'center',
    border: '1px solid #B3BBC7',
    marginBottom: '2rem'
}))

export const LoadingContainer = styled('div', ({ $theme }) => ({
    marginTop: '20%',
    height: '100%'
}))

export const AddPaymentTitle = styled('div', ({ $theme }) => ({
    ...$theme.typography.HeadingSmall,
    marginBottom: '1.2rem'
}))
